import { Box } from "@mui/material";
import { ErrorMessage } from "formik";

type Props = {
  name: string;
  gridName: string;
  index: number;
};

const ErrorValidationOnGrid = (props: Props) => {
  const { name, gridName, index } = props;
  return (
    <Box>
      <ErrorMessage
        name={name}
        render={(msg: any) => (
          <span className="text-danger font-size-sm">
            {msg?.[index]?.[gridName]}
          </span>
        )}
      />
    </Box>
  );
};

export default ErrorValidationOnGrid;
